
export default {

  init(basket) {
        // Checks if package protection should be added by default to all new
        // customer checkouts. Returns a settings object with information for displaying
        // the package protection option in the checkout.

    const settings = window.themeConfiguration.packageProtection;

    const defaultConfig = {
      enabled: false,
      optOut: false,
      product: {
        title: 'Missing Product',
        description: 'Missing Product',
        price: 0,
        handle: null,
      },
    };

    if (!basket) {
      window.console.error('Basket object not found: cannot set Package Protection');
      return defaultConfig;
    }

    if (!settings) {
      window.console.error('Package protection config not found: check config in Theme Editor');
      return defaultConfig;
    }

    if (!settings.enabled) {
      return defaultConfig;
    }

    if (!settings.product.handle) {
      window.console.error('Package protection product not found: check config in Theme Editor');
      return defaultConfig;
    }

    basket.setPackageProtection(settings.optOut);

    return settings;
  },

  get product() {
    const productId = window.themeConfiguration.packageProtection.product.id;
    const productCatalog = window.mosaic.products;

    if (!productCatalog) {
      window.console.error('Product catalog not found: cannot get Package Protection');
    }
    return productCatalog.find((product) => product.id === productId);
  },

};
